<p-toast></p-toast>
<div class="mat-elevation-z8">
    <p-footer style="display: flex;align-items: center;margin-left: 15px;margin-top: 15px;">
        <div style="margin-right: 40px;">
            <img [src]="this.provider_img" height="150px" width="150px" style="border-radius: 50%;">
        </div>
        <div style="margin-right: 30px;">
            <h3>{{ this.provider_name}}</h3>
        </div>
        <div class="ui-helper-clearfix" style="margin-right: 30px;">
            <button type="button" pButton style="float:left" (click)="showDialogToAdd()" label="Update Logo"></button>
        </div>
        <!-- <div class="ui-helper-clearfix">
            <button type="button" pButton style="float:left" (click)="showDialogToAddDetails()"
                label="Add Support Information"></button>
        </div> -->
    </p-footer>
    <br><br>

    <p-dialog header="Upload Logo" *ngIf="createDialog" [(visible)]="createDialog" [responsive]="true" showEffect="fade"
        (onHide)="Cancel()" [modal]="true">
        <div class="ui-grid ui-grid-responsive ui-fluid">

            <div class="ui-g">
                <div class="ui-g-12 ui-md-4" style="width:40%">
                    <label for="Update Logo"> <b>Update Logo:</b></label>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p-fileUpload name="file" (onSelect)="uploadFiles($event.files)" (onRemove)="clearfile()" [showUploadButton]="false"
                        styleClass="p-fileUpload-label-fix" [showCancelButton]="false" [maxFileSize]="5033165"
                        [multiple]="false" [fileLimit]="1" accept="image/*">
                    </p-fileUpload>
                </div>
            </div>
            <div class="alert alert-danger" role="alert">
                <p class="text-center text-gray-underline"><span class="font-weight-bold">Note</span>: The file type
                    supported for Speciality Image are
                    JPEG,JPG,PNG.</p>
            </div>
        </div>
        <p-footer>
            <p-progressSpinner *ngIf="posting"
                [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
            </p-progressSpinner>
            <button type="button" [disabled]="posting || !file" style="margin-bottom:10px;margin-right:5px;width:190px;"
                pButton (click)="save()" label="Save"></button>
            <button type="button" [disabled]="posting" style="margin-bottom:10px;margin-right:5px;width:190px;" pButton
                (click)="Cancel()" label="Cancel"></button>
        </p-footer>
        <div class="row">
            <div class="mt-3 mx-2">
                <div class="row">
                    <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                </div>
                <app-error-messages [api_result]="this.updatemetadata.create_api_result"></app-error-messages>
            </div>
        </div>
    </p-dialog>
    <p-dialog header="Upload Contact Information" *ngIf="this.createDialogDetails" [style]="{ width: '30vw' }"
        [(visible)]="this.createDialogDetails" [responsive]="true" showEffect="fade" (onHide)="Cancel1()" [modal]="true">
        <form accept-charset="UTF-8" (ngSubmit)="UpdateSupportDetails()" #SupportDetailsForm="ngForm">
            <div class="form-unit">
                <label class="form-unit-label" style="display: block; margin-bottom: 5px; font-weight: bolder">Phone
                    Number<span style="color: red;">*</span></label>
                <input type="text" pInputText id="phnumber" name="phnumber" aria-describedby="phnumber"
                    placeholder="Enter Phone Number*"
                    [(ngModel)]="this.updatesupportdata.api_data.contact.support.phoneNumber" #phnumber="ngModel"
                    [pKeyFilter]="number_input" [pattern]="phoneNumber" maxlength="20"
                    [class.form-input-error]="phnumber.invalid && (phnumber.dirty || phnumber.touched) && phnumber.errors.required"
                    [class.form-input-success]="!phnumber.invalid && (phnumber.dirty || phnumber.touched) && !phnumber.errors?.required"
                    required />
                <div *ngIf="phnumber.invalid && (phnumber.dirty || phnumber.touched)" class="alert alert-danger">
                    <div *ngIf="phnumber.errors.required" class="alert alert-danger m-2" role="alert">
                        Phone Number is required.
                    </div>
                    <div *ngIf="phnumber.errors.FieldValidator" class="alert alert-danger m-2" role="alert">
                        Invalid Phone Number.
                    </div>
                </div>
                <div *ngIf="phnumber.errors?.pattern" class="col-sm-12 alert alert-danger m-2" role="alert">
                    Only Numbers are allowed.
                </div>
            </div>
            <div class="form-unit">
                <label class="form-unit-label"
                    style="display: block; margin-bottom: 5px; font-weight: bolder">Email<span
                        style="color: red;">*</span></label>
                <input type="text" pInputText id="email" name="email" aria-describedby="email"
                    placeholder="Enter Email*" [(ngModel)]="this.updatesupportdata.api_data.contact.support.email"
                    #email="ngModel" FieldValidator="email"
                    [class.form-input-error]="email.invalid && (email.dirty || email.touched) && email.errors.required"
                    [class.form-input-success]="!email.invalid && (email.dirty || email.touched) && !email.errors?.required"
                    required />
                <div *ngIf="email.invalid && (email.dirty || email.touched)" class="alert alert-danger">
                    <div *ngIf="email.errors.required" class="alert alert-danger m-2" role="alert">
                        Email is required.
                    </div>
                    <div *ngIf="email.errors.FieldValidator" class="alert alert-danger m-2" role="alert">
                        Invalid Email.
                    </div>
                </div>
            </div>
            <div class="form-unit">
                <label class="form-unit-label"
                    style="display: block; margin-bottom: 5px; font-weight: bolder">Address<span
                        style="color: red;">*</span></label>
                <input type="text" pInputText id="address" name="address" aria-describedby="address"
                    placeholder="Enter Address*" [(ngModel)]="this.updatesupportdata.api_data.contact.support.address"
                    #address="ngModel" [pKeyFilter]="address"
                    [class.form-input-error]="address.invalid && (address.dirty || address.touched) && address.errors.required"
                    [class.form-input-success]="!address.invalid && (address.dirty || address.touched) && !address.errors?.required"
                    required />
                <div *ngIf="address.invalid && (address.dirty || address.touched)" class="alert alert-danger">
                    <div *ngIf="address.errors.required" class="alert alert-danger m-2" role="alert">
                        Address is required.
                    </div>
                    <div *ngIf="address.errors.FieldValidator" class="alert alert-danger m-2" role="alert">
                        Invalid Address.
                    </div>
                </div>
            </div>

            <div class="ui-g" style="text-align: center">
                <div class="ui-g-12">
                    <button type="submit" [disabled]="posting" style="margin-bottom:10px;margin-right:5px;width:190px;"
                        pButton label="Submit"></button>

                </div>
            </div>
        </form>
        <p-footer>
            <p-progressSpinner *ngIf="posting"
                [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
            </p-progressSpinner>

        </p-footer>
        <div class="row">
            <div class="mt-3 mx-2">
                <div class="row">
                    <app-loading class="col-12 text-center" *ngIf="isPosting()" type="SMALL_LOADER">
                    </app-loading>
                </div>
                <app-error-messages [api_result]="this.updatesupportdata.create_api_result"></app-error-messages>
            </div>
        </div>
    </p-dialog>
    <ng-container>
        <div class="ui-g-12">
            <div class="ui-g-12">
                <div class="ui-g">
                    <div class="card two-d-card ui-g-12" style="padding: 10px; border-radius: 8px;">
                        <div class="card-body heading4">
                            <div class="ui-g-12" style="display: flex; flex-wrap: wrap;">
                                <div class="ui-g-12 ui-lg-8">
                                    <p class="status_heading"><b>Support Details:</b></p>
                                    <div class="heading4" style="margin-bottom: 8px;">
                                        <span class="egd-color">Phone Number: </span> {{this.phone_number == 0 ? 'N/A' : this.phone_number}}
                                        <span style="margin-left: 40px;"></span>
                                        <span class="egd-color">Email: </span> {{this.email == '' ? 'N/A' : this.email}}
                                    </div>
                                    <div class="heading4" style="margin-bottom: 8px;">
                                        <span class="egd-color">Address: </span> {{this.address1 == '' ? 'N/A' : this.address1}}
                                    </div>
                                </div>
                                <div class="ui-g-12 ui-lg-4" style="text-align: right;">
                                    <button pButton type="button" label="Update Information" 
                                        icon="pi pi-external-link" 
                                        [disabled]="this.posting" 
                                        (click)="showDialogToAddDetails()" 
                                        class="btn btn-primary card-buttons">
                                    </button>
                                </div>
                            </div>
                            <div class="ui-g-12">
                                <p style="margin-top: 20px;"><span style="color: red; margin-top: 20px;">Note*:</span> Above details will be used as support contact details for your company.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    
</div>